/**
 * /connect-phone — signing Nucleus in on an iPhone.
 *
 * The iPhone app opens this page in a sign-in sheet (ASWebAuthenticationSession)
 * with a PKCE challenge. The person is asked — a press, never a silent redirect,
 * because this hands a whole sign-in to an app on their phone — and the code goes
 * back to the app's own scheme (nucleus://auth/callback) and nowhere else. The
 * code is bound to the challenge, so it is worth nothing to anything but the app
 * that asked, and the app carries no key (backend PHONE_AUDIENCE). Drawn by
 * DeviceSignIn, as every program of ours signing in is.
 */
import { useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import DeviceSignIn from '../../components/grant/DeviceSignIn';

// The only place a phone code may be sent: the app's own scheme. Anything else
// in the URL is ignored rather than trusted.
export function phoneCallback(code, state, error = null) {
  const q = new URLSearchParams(error ? { error, state: state || '' } : { code, state: state || '' });
  return `nucleus://auth/callback?${q}`;
}

export default function ConnectPhoneRoute() {
  const [params] = useSearchParams();
  const challenge = params.get('code_challenge');

  return (
    <DeviceSignIn
      app="Nucleus" where="this iPhone" testId="connect-phone"
      device={(params.get('device') || '').trim()}
      asked="pressed Sign in in Nucleus on your iPhone"
      retry="Press Sign in in Nucleus on your iPhone"
      can={['Do what you can do in Nucleus on the web']}
      valid={!!challenge && challenge.length >= 43 && challenge.length <= 128}
      sent="Going back to Nucleus."
      approve={async () => {
        const r = await api.createLoginHandoffCode('nucleus-iphone', challenge);
        window.location.href = phoneCallback(r.code, params.get('state'));
      }}
      deny={() => { window.location.href = phoneCallback('', params.get('state'), 'access_denied'); }}
    />
  );
}
